let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("107zu"), load("5CdWD"), load("75rSO")]).then(() => parcelRequire('1HlBH'));